/* eslint-disable no-undef */
import { useParams } from 'react-router-dom'
import useDirection from 'hooks/useDirection'
import { Dir, SUPPORT_RTL_LOCALES } from 'constants/vars'
import { DefaultFastestImageDomain } from 'store/data/Base'
import Cookies from 'js-cookie'
import { isCnSite } from 'constants/base'

/**
 * 请求响应码
 */
export enum Code {
    OK = '00000',
    SUCCESS = '200'
}

export const isSuccess = (code: Code | any): boolean => {
    return code === Code.SUCCESS || code === Code.OK
}

// 这些非成功的 code 也可以忽略，静默失败，不做提示
export const isIgnoreCode = (code: Code | any): boolean => {
    // 30012 策略平台不存在该策略（策略没同步到策略平台而已，静默失败即可）
    return ['30012'].includes(code);
}

/***
 * 获取当前 utc 时区
 */
export const getUtcZone = () => {
    let timezone = new Date().getTimezoneOffset() / 60
    if (timezone > 0) {
        return 'UTC-' + timezone
    }
    return 'UTC+' + Math.abs(timezone)
}

export const scientificToNumber = inputNumber => {
    if (isNaN(inputNumber) || !inputNumber) {
        return inputNumber
    }
    inputNumber = '' + inputNumber
    inputNumber = parseFloat(inputNumber)
    let eformat = inputNumber.toExponential() // 转换为标准的科学计数法形式（字符串）
    let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/) // 分离出小数值和指数值
    let number = inputNumber.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]))
    return number
}

export async function openGlobalKYCDialog(code?: string) {
    try {
        await window.MicroRuntime.getComponent({
            type: 'KycGuideDialog'
        }).instance.openKycDialog(code)
    } catch (e) {
        console.error('handleOpenGlobalKYCDialog', e)
    }
}

// 去除结尾所有多余 0
// 科学计数法也可以哟
export const removeEndZero = (num: string | number) => {
    let n = Number(num)
    if (isNaN(n)) return num

    let flag = ''
    if (typeof num === 'string' && /^\+/.test(num) && n !== 0) {
        flag = num.match(/^\+/)[0]
    }
    let m = n.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/)
    return `${flag}${n.toFixed(Math.max(0, (m[1] || '').length - Number(m[2])))}`
}

// K = 10的三次方，即千M = 10到6次方，即百万B = 10的9次方，即10亿T = 10到12，即万亿
export const formatNumberWithUnit = (num: string | number, fixed = 2) => {
    let n = Number(num)
    if (isNaN(n)) return num

    let flag = ''
    if (typeof num === 'string' && /^\+/.test(num) && n !== 0) {
        flag = num.match(/^\+/)[0]
    }
    if (n >= 1000000000000) {
        return `${flag}${(n / 1000000000000).toFixed(fixed)}T`
    } else if (n >= 1000000000) {
        return `${flag}${(n / 1000000000).toFixed(fixed)}B`
    } else if (n >= 1000000) {
        return `${flag}${(n / 1000000).toFixed(fixed)}M`
    } else if (n >= 1000) {
        return `${flag}${(n / 1000).toFixed(fixed)}K`
    } else {
        return `${flag}${n.toFixed(fixed)}`
    }
}

export const FASTEST_IMAGE_DOMAIN_KEY = 'fatest_image_domain'

// 加载gtm.js
export const loadGtm = (result = {isMarketing: 0, isStatistic: 0}) => {
    try {
        const optanonConsent  = Cookies.get('OptanonConsent') 
        const isMarketing  = result.isMarketing || optanonConsent.includes('isMarketing=1')
        if (isMarketing) {
            // window.addEventListener('DOMContentLoaded', () => {
                const fragment = document.createDocumentFragment()
                const scriptList = [{
                    src:'/trading-bot/thirdParty/analyze.js',
                    defer: true
                }]
                scriptList.forEach(({ src, async, defer }) => {
                    // `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WQ4HTBR" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`
                    const script = document.createElement('script')
                    script.src = src
                    script.type = 'text/javascript'
                    async && (script.async = async)
                    defer && (script.defer = defer)
                    fragment.appendChild(script)
                })
                document.body.appendChild(fragment)
            // })
        }
    } catch (e) {
        console.log(e)
    }
}

export const getCookiesOptanonConsent = () => {
    const cookiess = document.cookie.split(';')
    const keyValue = cookiess
        .find((mp) => mp.split('=')[0].trim() === 'OptanonConsent')
        ?.replace(/OptanonConsent=/, '?')
        .trim()
    return Object.fromEntries(new URLSearchParams(keyValue).entries())
}

// cookie隐私合规gtag方法
export const gtagCookieSet = () => {
    const cookiesObj = getCookiesOptanonConsent()
    try {
        if(!('isMarketing' in cookiesObj)){
            gtag && gtag('consent', 'default', {
                ad_storage: 'denied', 
                ad_user_data: 'denied', 
                ad_personalization:  'denied', 
                analytics_storage: 'denied'
            })
          } else {
            const isMarketing  =  cookiesObj.isMarketing == '1';
            const isStatistic  =  cookiesObj.isStatistic == '1';
            gtag && gtag('consent', 'default', {
                ad_storage: isMarketing ? 'granted' : 'denied', 
                ad_user_data: isMarketing ?'granted':'denied',
                ad_personalization: isMarketing ?'granted':'denied', 
                analytics_storage: isStatistic ?'granted':'denied'
            })
          }
    } catch (e) {
        console.log(e)
    }
}
